import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomInrPipe } from '../pipe/custom-inr.pipe';



@NgModule({
  declarations: [CustomInrPipe],
  imports: [
    CommonModule
  ],
  exports:[CustomInrPipe]
})
export class SharedModule { }
